var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"row m-0"},[_c('div',{staticClass:"col-12 p-0"},[_c('router-view')],1),_c('div',{staticClass:"col-12 p-0 menu-profile"},[_c('div',{staticClass:"mb-2"},[_c('Profile')],1),_c('div',[_c('MenuProfile')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }